{
    "AlarmonnewabandonedcallLabel": "Alarme sur nouvel appel abandonné :",
    "NAME": "AbandonedCallAlarm",
    "AbandonedCallAlarm_SectionHeader": "Alarme d'appel abandonné",
    "AbandonedCallAlarm_SectionPara": "Vous pouvez activer une alarme lorsque de nouveaux appels abandonnés se produisent."
}